import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormHeading from "../../UI_Design/FormComponents/Heading/FormHeading";
import {
  getEmployementExperienceOptions,
  getEmploymentGapReason,
  getEmploymentValidation,
  saveEmployementExperienceOption,
} from "../../Actions/employementActions_v2";
import {
  addEmployment,
  deleteAddEmploymentData,
  deletePrevEmploymentCountData,
  deleteSaveEmployment,
  getEmployment,
  getReasonOfLeavingOptions,
  saveEmployment,
} from "../../Actions/employmentActions";
import Tabs from "./TabsAndContent/Tabs";
import EmploymentForm from "./TabsAndContent/EmploymentForm";
import GetMasterData from "../../Helper/masterData";
import { getData } from "../../Actions/landingAction";
import ConfirmationPopup from "../EmploymentForm/confirmationPopup";
import EmpLoymentQuestionDropdown from "./EmploymentFormFields/EmpLoymentQuestionDropdown";
import TenureAlertPopUp from "./TabsAndContent/TenureAlertPopUpNew";
import Loader from "../Common/loader";
import EmploymentGapFormContainer from "./EmploymentGapFormContainer";
import EmploymentTab from "./TabsAndContent/EmploymentTab";
import EmploymentGapFormWrapper from "./EmploymentGapFormWrapper";
import EmpStatusConfirmationPopup from "./TabsAndContent/EmpStatusConfirmationPopup"
import {
  alphabetsAndSpace,
  documentCheckboxDisabledClients,
  excludedFields,
  hrAndRMFields,
  instantFieldsMapping,
  instantModesFields,
  numbers711,
  numericOnly,
} from "../EmploymentForm/empConstants";
import { toast } from "react-toastify";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { getMRLDocument } from "../../Actions/educationActions";

const FormContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const ref = useRef();

  const handleScroll = () => {
    const formGroups = ref.current.querySelector('.py-3 p.err');

    console.log("error rrrr..", formGroups)
    if (formGroups) {
      formGroups.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
    }
  }

  const { stateOptionspv, currencyOptions, countryCodeOptions } =
    GetMasterData();
  const { loading, employmentData } = useSelector(
    (state) => state.employment || {}
  );

  const { employmentSaveData, loading: employmentSaveDataLoading } =
    useSelector((state) => state.employmentSaveData);
  const {
    checksDetails,
    clientId,
    showProfilePreview,
    is_employment_validation,
    is_gap_reason,
    referenceNo,
    candidates,
    cross_btn_emp, //for Remove Button
    is_custom_employement, // for add buttton
    employment_config_msg,
    is_disable_emp_question,
    company_date_of_joining,
    package_id,
  } = employmentData?.data?.data || {};

  const storeMRLDocument = useSelector((state) => state.MRLDocument || {});
  const {
    MRLDocumentData,
    loading: Loading,
    error: saveErr,
  } = storeMRLDocument;

  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(1); // will store case check id
  const [employmentStatus, setEmploymentStatus] = useState(0);
  const [tempEmploymentStatus, setTempEmploymentStatus] = useState(0);
  const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
  const [reasonOfLeavingOpt, setReasonOfLeavingOpt] = useState({});
  const [currencies, setCurrencies] = useState({});
  const [states, setStates] = useState([]);
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);

  const [catchIfAllStatusInComplete, setCatchIfAllStatusInComplete] =
    useState(0);

  const [catchIfAllStatusMigrated, setCatchIfAllStatusMigrated] = useState(0);

  const [checkForAddEmployment, setCheckForAddEmployment] = useState(true);

  const [showAddPopup, setShowAddPopup] = useState(false);

  const [groupId, setGroupId] = useState(null);

  const [hasGap, setHasGap] = useState(false);
  const [gapReasonKey, setGapReasonKey] = useState("emp");
  const [gapData, setGapData] = useState({});
  const [finalCaseCheckId, setFinalCaseCheckId] = useState(null);
  const [finalDataToBeSent, setFinalDataToBeSent] = useState({});
  const [etypeErrorPopUp, setEtypeErrorPopUp] = useState(false);
  const [etypeInfo, setEtypeInfo] = useState(null);
  const [etypeShowGap, setETypeShowGap] = useState(null);
  const [showAlertPopUp, setShowAlertPopUp] = useState(false);
  const [showStatusPopUp, setShowStatusPopUp] = useState(false);
  const [showETypeOverlap, setShowETypeOverlap] = useState(false);

  /***States for form imnputs */

  const [allFormInputsField, setAllFormInputFields] = useState({});
  const [allFormInputErrors, setAllFormInputErrors] = useState({});
  const [isSelfEmployed, setIsSelfEmployed] = useState({});
  const [isSSN, setIsSSN] = useState({});

  const [showOtherVerificationSource, setShowOtherVerificationSource] =
    useState({});
  const [otherVerificationSource, setOtherVerificationSource] = useState({});
  const [otherVerificationError, setOtherVerificationError] = useState({});

  const [otherDesignation, setOtherDesignation] = useState({});
  const [showOtherDesignation, setShowOtherDesignation] = useState({});
  const [otherDesignationError, setOtherDesignationError] = useState({});

  const [otherReasonLeaving, setOtherReasonLeaving] = useState({});
  const [showOtherReasonLeaving, setShowOtherReasonLeaving] = useState({});
  const [otherReasonLeavingError, setOtherReasonLeavingError] = useState({});

  const [otherLocation, setOtherLocation] = useState({});
  const [showOtherLocation, setShowOtherLocation] = useState({});
  const [otherLocationError, setOtherLocationError] = useState({});

  const [tillDateChecked, setTillDateChecked] = useState({});
  const [canConnectWithManager, setCanConnectWithManager] = useState({});
  const [canConnectWithManager1, setCanConnectWithManager1] = useState({});
  const [isDocProvidedChecked, setIsDocProvidedChecked] = useState({});

  const [uploadedDocuments, setUploadedDocuments] = useState({});
  const [requiredDocuments, setRequiredDocuments] = useState({});

  const [mobileCode, setMobileCode] = useState({});

  const [showDisableWarning, setShowDisableWarning] = useState(false);

  const [lastTabCaseCheckId, setLastTabCaseCheckId] = useState(null);

  const [currentStatusDropdownFlag, setCurrentStatusDropdownFlag] = useState(0);

  const [showStatusDOJ, setShowStatusDOJ] = useState(0);

  useEffect(() => {
    if (checksDetails?.length) {
      const tempTabs = checksDetails.map((element, index) => {
        const caseCheckId = element?.case_check_id;
        return {
          name: `Employment ${index + 1}`,
          path: `${element?.case_check_id}`,
          index: index,
          content: (
            <EmploymentForm
              key={index}
              index={index + 1}
              clientId={clientId}
              checkData={element}
              reasonOfLeavingOpt={reasonOfLeavingOpt}
              states={states}
              currencies={currencies}
              countryCodeOptions={countryCodeOptions}
              showProfilePreview={showProfilePreview}
              totalTabs={checksDetails?.length}
              isEmpValidationRequired={is_employment_validation}
              isGapReason={is_gap_reason}
              catchIfAnyStatusIsNotCompleted={catchIfAnyStatusIsNotCompleted}
              setCheckForAddEmployment={setCheckForAddEmployment}
              crossButtonEnabled={cross_btn_emp}
              setShowAlertPopUp={setShowAlertPopUp}
              setETypeShowGap={setETypeShowGap}
              setEtypeErrorPopUp={setEtypeErrorPopUp}
              setGapData={setGapData}
              setFinalCaseCheckId={setFinalCaseCheckId}
              setFinalDataToBeSent={setFinalDataToBeSent}
              setHasGap={setHasGap}
              setGapReasonKey={setGapReasonKey}
              setEtypeInfo={setEtypeInfo}
              etypeInfo={etypeInfo}
              saveEmploymentCallback={saveEmploymentCallback}
              setAllFormInputErrors={setAllFormInputErrors}
              setAllFormInputFields={setAllFormInputFields}
              fieldInput={allFormInputsField[caseCheckId] || {}}
              errorData={allFormInputErrors[caseCheckId] || {}}
              isSelfEmployed={isSelfEmployed[caseCheckId]}
              setIsSelfEmployed={setIsSelfEmployed}
              isSSN={isSSN[caseCheckId]}
              setIsSSN={setIsSSN}
              showOtherVerificationSource={
                showOtherVerificationSource[caseCheckId]
              }
              setShowOtherVerificationSource={setShowOtherVerificationSource}
              otherVerificationSource={otherVerificationSource[caseCheckId]}
              setOtherVerificationSource={setOtherVerificationSource}
              otherVerificationError={otherVerificationError[caseCheckId]}
              setOtherVerificationError={setOtherVerificationError}
              otherDesignation={otherDesignation[caseCheckId]}
              setOtherDesignation={setOtherDesignation}
              showOtherDesignation={showOtherDesignation[caseCheckId]}
              setShowOtherDesignation={setShowOtherDesignation}
              otherDesignationError={otherDesignationError[caseCheckId]}
              setOtherDesignationError={setOtherDesignationError}
              otherReasonLeaving={otherReasonLeaving[caseCheckId]}
              setOtherReasonLeaving={setOtherReasonLeaving}
              showOtherReasonLeaving={showOtherReasonLeaving[caseCheckId]}
              setShowOtherReasonLeaving={setShowOtherReasonLeaving}
              otherReasonLeavingError={otherReasonLeavingError[caseCheckId]}
              setOtherReasonLeavingError={setOtherReasonLeavingError}
              otherLocation={otherLocation[caseCheckId]}
              setOtherLocation={setOtherLocation}
              showOtherLocation={showOtherLocation[caseCheckId]}
              setShowOtherLocation={setShowOtherLocation}
              otherLocationError={otherLocationError[caseCheckId]}
              setOtherLocationError={setOtherLocationError}
              tillDateChecked={tillDateChecked[caseCheckId]}
              setTillDateChecked={setTillDateChecked}
              canConnectWithManager={canConnectWithManager[caseCheckId]}
              setCanConnectWithManager={setCanConnectWithManager}
              canConnectWithManager1={canConnectWithManager1[caseCheckId]}
              setCanConnectWithManager1={setCanConnectWithManager1}
              isDocProvidedChecked={isDocProvidedChecked[caseCheckId]}
              setIsDocProvidedChecked={setIsDocProvidedChecked}
              uploadedDocuments={uploadedDocuments[caseCheckId]}
              setUploadedDocuments={setUploadedDocuments}
              requiredDocuments={requiredDocuments[caseCheckId]}
              setRequiredDocuments={setRequiredDocuments}
              mobileCode={mobileCode[caseCheckId]}
              setMobileCode={setMobileCode}
              saveHandler={saveHandler}
              JLLdoj = {company_date_of_joining}
              employment_status = {candidates?.employment_status}
              package_id={package_id}
              MRLDocs = {MRLDocumentData ? MRLDocumentData[caseCheckId] : {}}
            />
          ),
        };
      });
      if(candidates?.employment_status) {
        setEmploymentStatus(candidates?.employment_status);
      }
        if (candidates?.employment_status < 2) {
          setTabs([]);
        } else if(!!(candidates?.employment_status === 2 || candidates?.employment_status === 3) && catchIfAllStatusMigrated){
          setTabs([]);
        } else if (tempTabs?.length) {
        setTabs(tempTabs);
      }
    } else if(!checksDetails?.length && candidates?.employment_status) { // emp and emp via uan
      setEmploymentStatus(candidates?.employment_status);
    } 
  }, [
    reasonOfLeavingOpt,
    allFormInputErrors,
    allFormInputsField,
    isSelfEmployed,
    isSSN,
    showOtherVerificationSource,
    otherVerificationSource,
    otherVerificationError,
    otherDesignation,
    showOtherDesignation,
    otherDesignationError,
    otherReasonLeaving,
    showOtherReasonLeaving,
    otherReasonLeavingError,
    otherLocation,
    showOtherLocation,
    otherLocationError,
    tillDateChecked,
    canConnectWithManager,
    canConnectWithManager1,
    isDocProvidedChecked, 
    uploadedDocuments,
    requiredDocuments,
    mobileCode,
    candidates, 
    catchIfAllStatusMigrated,
    MRLDocumentData
  ]);

  useEffect(()=> {
    const checkActiveTab = checksDetails?.find((check) => location.pathname.endsWith(check?.case_check_id))
    if(checkActiveTab?.case_check_id){
      setActiveTab(checkActiveTab?.case_check_id) // refreshing the name tab
    } else if(checksDetails?.length) {
      const firstIncompleteCheck = checksDetails.find(
        (element) => element?.check_status === 1
      );
      if(firstIncompleteCheck?.case_check_id) {
        changeTab(firstIncompleteCheck?.case_check_id); //navigate to incomplete check in case of remove and first visit.
      } else {
        changeTab(checksDetails[0].case_check_id); // in case of no active tab found first render
      }

    }
  },[location?.pathname, checksDetails])

  useEffect(() => {
    
    resetOthersField();
    if (checksDetails?.length) {
      const lastCheck = checksDetails[checksDetails?.length - 1];
      if(lastCheck?.case_check_id) {
        setLastTabCaseCheckId(lastCheck?.case_check_id);
      } else {
        setLastTabCaseCheckId(null);
      }
      let allTabchecked = Object.entries(checksDetails)?.every(
        ([key, value]) => value?.check_status === 2
      );

      let allTabUnChecked = Object.entries(checksDetails)?.every(
        ([key, value]) => value?.check_status === 1
      );

      let allTabMigrated = Object.entries(checksDetails)?.every(
        ([key, value]) => value?.check_status === 3
      );
      const firstIncompleteCheckIndex = checksDetails.findIndex(
        (element) => element?.check_status === 1
      );
      let val = allTabchecked ? 0 : 1;
      if (checkForAddEmployment == false) {
        val = 0;
      }

      checksDetails.map((element, index) => {
        const caseCheckId = element?.case_check_id;
        let initialInput = {};
        let initialErrorData = {};
        if (element?.fields) {
          for (let i in element?.fields) {
            initialInput[i] = element?.fields[i]?.field_value;
            initialErrorData[i] = false;

            if (i === "work_status") {
              const isSelfEmployedinitial =
                element?.fields[i].field_value === "Self Employed"
                  ? true
                  : element?.fields[i].field_value === "Employed in a company"
                  ? false
                  : null;
              setIsSelfEmployed((prevState) => ({
                ...prevState,
                [caseCheckId]: isSelfEmployedinitial,
              }));
            }

            if (
              i == "is_ssn_country" &&
              element?.fields[i].field_value !== ""
            ) {
              if (element?.fields[i].field_value == "Yes") {
                setIsSSN((prevState) => ({
                  ...prevState,
                  [caseCheckId]: true,
                }));
              } else {
                setIsSSN((prevState) => ({
                  ...prevState,
                  [caseCheckId]: false,
                }));
              }
            }

            if (i === "till_date") {
              const initialTillDateChecked =
                element?.fields[i].field_value === "1" ? true : false;
              setTillDateChecked((prevState) => ({
                ...prevState,
                [caseCheckId]: initialTillDateChecked,
              }));
            }

            if (i === "connect_with_manager") {
              const canConnect =
                element?.fields[i].field_value === "Yes" ||
                element?.fields[i].field_value === ""
                  ? true
                  : false;
              setCanConnectWithManager((prevState) => ({
                ...prevState,
                [caseCheckId]: canConnect,
              }));
            }
            if (i === "connect_with_manager1") {
              const canConnect =
                element?.fields[i].field_value === "Yes" ||
                element?.fields[i].field_value === ""
                  ? true
                  : false;
              setCanConnectWithManager1((prevState) => ({
                ...prevState,
                [caseCheckId]: canConnect,
              }));
            }

            if (i === "is_document_provided") {
              const isDocProvidedCheckedObjInitial =
                element?.fields[i].field_value === "1" 
                // || element?.document_visibility !== 1
                  ? true
                  : false;
              setIsDocProvidedChecked((prevState) => ({
                ...prevState,
                [caseCheckId]: isDocProvidedCheckedObjInitial,
              }));
            }
          }

          setUploadedDocuments((prevState) => ({
            ...prevState,
            [caseCheckId]: element?.uploaded_documents,
          }));

          setRequiredDocuments((prevState) => ({
            ...prevState,
            [caseCheckId]: element?.required_documents,
          }));

          setAllFormInputFields((prevstate) => ({
            ...prevstate,
            [caseCheckId]: initialInput,
          }));

          setAllFormInputErrors((prevstate) => ({
            ...prevstate,
            [caseCheckId]: initialErrorData,
          }));
        }
      });
      setCatchIfAnyStatusIsNotCompleted(val);
      setCatchIfAllStatusInComplete(allTabUnChecked);
      setCatchIfAllStatusMigrated(allTabMigrated);
      getMRLDocList(checksDetails);
    }
  }, [checksDetails]);

  // useEffect(() => {
  //   if (candidates?.employment_status) {
  //     setEmploymentStatus(candidates?.employment_status);
  //     if (candidates?.employment_status < 2) {
  //       console.log("running line 387");
  //       setTabs([]);
  //     } else if(candidates?.employment_status === 2 || candidates?.employment_status === 3){
  //       console.log("reaching here...")
  //       if(catchIfAllStatusMigrated){
  //         console.log("running line 392");
  //         setTabs([]);
  //       }
  //     }
  //   }
  // }, [candidates, catchIfAllStatusMigrated]);


  useEffect(() => {
    dispatch(getEmployementExperienceOptions(getOptions));
    dispatch(getEmployment());
    dispatch(getReasonOfLeavingOptions(setReasonCallback));
    dispatch(getData()); // to get updated employent form status
    return () => {
      dispatch({ type: "MRL_DOCUMENT_RESET" });
      dispatch({ type : "EMPLOYMENT_SUCCESS", payload : []})
    };
  }, []);

  useEffect(() => {
    let obj2 = {};
    for (var j in currencyOptions) {
      obj2[currencyOptions[j].value] = currencyOptions[j].label.currency;
    }
    setStates(stateOptionspv);
    setCurrencies(obj2);
  }, [stateOptionspv, currencyOptions]);

  // useEffect(() => {
  //   if (employmentSaveData?.data) {
  //     const groupId =
  //       employmentSaveData?.data?.group?.group_id ||
  //       employmentSaveData?.data?.group;
  //     const nextCheckId = employmentSaveData?.data?.nextCheck;
  //     const findNextCheckIndex = checksDetails?.findIndex(
  //       (check) => check?.case_check_id == nextCheckId
  //     );
  //     if (groupId == "profile_preview") {
  //       navigate(`/case-initiation/profile-preview/${referenceNo}`);
  //     } else if (groupId == 4 && nextCheckId && !!(findNextCheckIndex + 1)) {
  //       // changeTab(findNextCheckIndex + 1);
  //       // setActiveTab(findNextCheckIndex + 1);
  //       dispatch(getEmployment());
  //     } else {
  //       navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`);
  //     }
  //     dispatch(deleteSaveEmployment());
  //   }
  // }, [employmentSaveData]);

  useEffect(() => {
    console.log("etypeInfo...", etypeInfo);
    if (etypeInfo?.data) {
      // if (etypeInfo?.data?.show_gap && etypeInfo?.data?.show_gap == "1") {
      //   setETypeShowGap(true);
      // } else {
      //   setEtypeErrorPopUp(true);
      // }
      if(etypeInfo?.data?.etype === "Overlapping Employments!" || etypeInfo?.data?.etype === "Same Employments!") {
        setShowETypeOverlap(true);
      } else {
        setETypeShowGap(true);
      }
    }
  }, [etypeInfo]);

  useEffect(() => {
    setCurrentStatusDropdownFlag(is_disable_emp_question)
  },[is_disable_emp_question])

  const handleAddPopup = (e) => {
    e?.preventDefault();
    closeGapPopUp();
    setShowAddPopup(true);
  };

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

  const proceedAdd = async () => {
    await dispatch(addEmployment());
    await dispatch(getData());
    // reRenderAgain(unsavedEmpData);
    dispatch(getEmployment());
    setShowAddPopup(false);
    // checkMaximumEmploymentTab();
  };

  const setReasonCallback = (data) => {
    data.push({ id: 0, reason: "Other" });
    setReasonOfLeavingOpt(data);
  };

  const getOptions = (data) => {
    if (data?.data?.length || Object.keys(data?.data || {})?.length) {
      const optionEntries = Object.entries(data?.data || {});
      const experienceOptions = optionEntries.map(option => option[1])
      setStatusDropdownOptions(experienceOptions);
    } else {
      setStatusDropdownOptions([]);
    }
    if(data?.showPopup) {
      setShowStatusDOJ(1);
    } else {
      setShowStatusDOJ(0);
    }
  };

  const handleDropdownChangeInternal = (event) => {
    const isCurrentEmpCheckPresent = checksDetails?.find(check => check?.check_id === 58); 
    let prevStatelocal = null;
    setTempEmploymentStatus(employmentStatus);
    if(!candidates?.employment_status){
      setTabs([]);
      // IB-21336 issue resolved
      // if(event?.target?.value == 1) {
      //   setShowDisableWarning(true);
      //   setShowStatusPopUp(true);
      // } else if(event?.target?.value == 2 || event?.target?.value == 3){
      //   if(isCurrentEmpCheckPresent && checksDetails?.length <= 1) {
      //     setShowDisableWarning(true);
      //     setShowStatusPopUp(true);
      //   }
      // }
      } else if(event?.target?.value == 2 || event?.target?.value == 3){
      if(isCurrentEmpCheckPresent && checksDetails?.length <= 1) {
        // show pop up with disable msg
        setShowDisableWarning(true);
      } else {
        setShowDisableWarning(false);
      }
    } else if (event?.target?.value ==  1) {
      // show pop up with disable msg
      setShowDisableWarning(true);
    } else {
      setShowDisableWarning(false);
    }
    setEmploymentStatus(event?.target?.value);
    if(candidates?.employment_status || !!(showStatusDOJ && event?.target?.value == 3)){
      setShowStatusPopUp(true);
    } else {
      setShowStatusPopUp(false);
    }
  };

  // const handleDropdownChangeInternal = (event) => {
  //   const newValue = event?.target?.value;
  //   const isCurrentEmpCheckPresent = checksDetails?.some(check => check?.check_id === 58);
    
  //   setTempEmploymentStatus(employmentStatus);
    
  //   // Handle dropdown state based on conditions
  //   const shouldShowWarning = 
  //     (!candidates?.employment_status && newValue == 1) ||
  //     (newValue == 2 || newValue == 3) && isCurrentEmpCheckPresent && checksDetails?.length <= 1;
  
  //   setShowDisableWarning(shouldShowWarning);
  //   setShowStatusPopUp(candidates?.employment_status || shouldShowWarning);
  
  //   // Reset tabs if employment status is not present
  //   if (!candidates?.employment_status) {
  //     setTabs([]);
  //   }
  
  //   setEmploymentStatus(newValue);
  // };
  

  const getGroupInfo = (data) => {
    const groupId = data?.data?.group?.group_id || data?.data?.group;
    setGroupId(groupId);
    setEmploymentStatus(tempEmploymentStatus);
    setTempEmploymentStatus("");
    dispatch(getData());
    if (groupId == 4) {
      navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`); // to render first tab ...conditon written in employmentTab to change the link
      dispatch(getEmployment());
    } else {
      console.log("running line 515");
      setTabs([]);
      if (groupId == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNo}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`);
      }
    }
  };

  const changeTab = (tabNumber) => {
    if (tabNumber) {
      navigate(`/case-initiation/check-detail/${referenceNo}/4/${tabNumber}`);
      setActiveTab(tabNumber);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const handleNextNavigation = (e) => {
    e?.preventDefault();
    dispatch(saveEmployementExperienceOption(employmentStatus, getGroupInfo));
  };

  const closeGapPopUp = () => {
    dispatch(getEmployment());
    setHasGap(false);
  };

  const handleGapReasonSubmit = (gapReasonData) => {
    // setIsLoading(true);
    let newFinalData = { ...finalDataToBeSent };
    let newGapData = [];
    for (var i in gapReasonData) {
      let obj = {};
      let category = null;
      for (var j in gapReasonData[i]) {
        if (["label", "tenure_to", "tenure_from"].includes(j)) {
          obj[`gap_${j}`] = gapReasonData[i][j];
        } else {
          if (j == "category") {
            category = gapReasonData[i][j];
          }
          obj[`${j}`] = gapReasonData[i][j];
        }
      }
      obj["gap_type"] = category;
      newGapData.push(obj);
    }
    newFinalData[finalCaseCheckId]["GapReason"] = newGapData;
    dispatch(
      saveEmployment(
        finalCaseCheckId,
        newFinalData,
        activeTab,
        saveEmploymentCallback
      )
    );
  };

  const proceedTenureAlert = async () => {
    setETypeShowGap(false);
    const gapReasonResult = await dispatch(
      getEmploymentGapReason(
        finalCaseCheckId,
        finalDataToBeSent,
        etypeInfo?.data?.show_declaration
      )
    );
    setEtypeInfo(null);
    if (
      gapReasonResult.data &&
      Object.keys(gapReasonResult.data).length > 0 &&
      gapReasonResult?.message != "No gap found."
    ) {
      setGapData(gapReasonResult.data);
      if (Object.keys(gapReasonResult.data.responseArr).includes("eduemp")) {
        setGapReasonKey("eduemp");
      }
      setHasGap(true);
    } else {
      dispatch(
        saveEmployment(
          finalCaseCheckId,
          finalDataToBeSent,
          activeTab,
          saveEmploymentCallback
        )
      );
    }
  };

  const handleAddEmployment = async () => {
    const updateFinalPayload = { ...finalDataToBeSent };
    updateFinalPayload[finalCaseCheckId].is_final_tab = 0;
    const currentCheckIndex = checksDetails?.findIndex(check => check?.case_check_id == activeTab);
    const nextCheck = checksDetails[currentCheckIndex + 1];
    if (lastTabCaseCheckId == activeTab) {
      await dispatch(addEmployment());
    } else if(nextCheck?.case_check_id) {
      changeTab(nextCheck?.case_check_id)
    }
    await dispatch(getData());
    // reRenderAgain(unsavedEmpData);
    await dispatch(
      saveEmployment(finalCaseCheckId, updateFinalPayload, activeTab, saveEmploymentCallback)
    );
    dispatch(getEmployment());
    setShowAddPopup(false);
    // await proceedAdd();
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    navigate(`/case-initiation/profile-preview/${referenceNo}`);
  };

  const saveEmploymentCallback = (savedEmployementData) => {
    // debugger;
    if (savedEmployementData) {
      const groupId =
        savedEmployementData?.group?.group_id || savedEmployementData?.group;
      const nextCheckId = savedEmployementData?.nextCheck;
      const findNextCheckIndex = checksDetails?.findIndex(
        (check) => check?.case_check_id == nextCheckId
      );
      if (groupId == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNo}`);
      } else if (groupId == 4 && nextCheckId) {
        changeTab(nextCheckId);
        setActiveTab(nextCheckId);
        dispatch(getEmployment());
      } else {
        navigate(`/case-initiation/check-detail/${referenceNo}/${groupId}`);
      }
      dispatch(deleteSaveEmployment());
    }
  };

  const saveHandler = (e, caseCheckId) => {
    e?.preventDefault();
    checkForMandatoryError(caseCheckId);
  };

  const checkForMandatoryError = (caseCheckId, addFlag) => {
    const checkData = checksDetails.find(check => check.case_check_id === caseCheckId)
    const { fields } = checkData || {};
    // const caseCheckId = checkData?.case_check_id;
    let updatedErrorData = {...allFormInputErrors[caseCheckId]};
    let fieldInput = {...allFormInputsField[caseCheckId]};
    for (var i in fields) {
      let isFieldMandatory = fields[i].is_mandatory;
      if (isSelfEmployed[caseCheckId] === true) { // it will not run for undefined and null cases also
        isFieldMandatory = hrAndRMFields.includes(i)
          ? 0
          : fields[i].is_mandatory;
      }
      if (i == "till_date") {
        isFieldMandatory =
        fieldInput["company_date_of_leaving"] &&
        fieldInput["company_date_of_leaving"] != ""
            ? 0
            : 1;
      }
      if (i == "ssn_number") {
        if (
          isSSN[caseCheckId] &&
          fieldInput["is_ssn_country"] &&
          fieldInput["ssn_number"].field_value.length != 9
        ) {
          updatedErrorData[i] = true;
        } else {
          updatedErrorData[i] = false;
        }
      }
      if (i == "company_name" && showOtherVerificationSource[caseCheckId] == true) {
        if (otherVerificationSource[caseCheckId] == "" || otherVerificationSource[caseCheckId] == null) {
          setOtherVerificationError((prevState) => ({
            ...prevState,
            [caseCheckId]: true,
          }));
        } else {
          setOtherVerificationError((prevState) => ({
            ...prevState,
            [caseCheckId]: false,
          }));
        }
      }
      if (i == "company_designation" && showOtherDesignation[caseCheckId] == true) {
        if (otherDesignation[caseCheckId] == "" || otherDesignation[caseCheckId] == null) {
          setOtherDesignationError((prevState) => ({
            ...prevState,
            [caseCheckId]: true,
          }));
        } else {
          setOtherDesignationError((prevState) => ({
            ...prevState,
            [caseCheckId]: false,
          }));
        }
      }
      if (i == "reason_for_leaving" && showOtherReasonLeaving[caseCheckId] == true) {
        if (otherReasonLeaving[caseCheckId] == "" || otherReasonLeaving[caseCheckId] == null) {
          setOtherReasonLeavingError((prevState) => ({
            ...prevState,
            [caseCheckId]: true,
          }));
        } else {
          setOtherReasonLeavingError((prevState) => ({
            ...prevState,
            [caseCheckId]: false,
          }));
        }
      }
      // if (i == "company_location" && showOtherLocation[caseCheckId] == true) {
      //   if (otherLocation[caseCheckId] == "" || otherLocation[caseCheckId] == null) {
      //     setOtherLocationError((prevState) => ({
      //       ...prevState,
      //       [caseCheckId]: true,
      //     }));
      //   } else {
      //     setOtherLocationError((prevState) => ({
      //       ...prevState,
      //       [caseCheckId]: false,
      //     }));
      //   }
      // }
      if (i == "company_date_of_leaving") {
        const isTillDateChecked =
          tillDateChecked[caseCheckId] && tillDateChecked[caseCheckId] == true ? true : false;
        if (isTillDateChecked) {
          isFieldMandatory = 0;
        }
      }
      if (i == "reliveing_letter_date") {
        const isTillDateChecked =
          tillDateChecked[caseCheckId] && tillDateChecked[caseCheckId] == true ? true : false;
        if (!isTillDateChecked) {
          isFieldMandatory = 0;
          updatedErrorData[i] = false;
        }
      }
      if(i == "address_of_company" && package_id != 19599 && !(showOtherVerificationSource[caseCheckId] == true)) {
        isFieldMandatory = 0;
        updatedErrorData[i] = false;
      }
      if(i == "company_contact_no" && !(showOtherVerificationSource[caseCheckId] == true)) {
        isFieldMandatory = 0;
        updatedErrorData[i] = false;
      }
      if (canConnectWithManager[caseCheckId]) {
        if (i == "manager_reason") {
          isFieldMandatory =
          canConnectWithManager[caseCheckId] == true ? 0 : fields[i].is_mandatory;
        }
      } else {
        if (i == "manager_reason") {
          isFieldMandatory = 0
        }
      }
      if (canConnectWithManager1[caseCheckId]) {
        if (i == "manager_reason1") {
          isFieldMandatory =
          canConnectWithManager1[caseCheckId] == true ? 0 : fields[i].is_mandatory;
        }
      } else {
        if (i == "manager_reason1") {
          isFieldMandatory = 0
        }
      }
      if(MRLDocumentData && MRLDocumentData[caseCheckId] && MRLDocumentData[caseCheckId]?.required_fields?.length) {
        const fieldIndexMRL = MRLDocumentData[caseCheckId]?.required_fields?.findIndex(mrlFieldID => mrlFieldID == fields[i].id);
        if(fieldIndexMRL > -1) {
          isFieldMandatory = 1
        } 
      }
      if (isFieldMandatory == 1 && !excludedFields.includes(i)) {
        if (fieldInput[i] == null || fieldInput[i].trim() == "") {
          updatedErrorData[i] = true;
        }
      }
    }
    if (isDocProvidedChecked[caseCheckId] == false) {
      const checkRequiredDocuments = requiredDocuments[caseCheckId] || [];
      const checkUploadedDocuments = uploadedDocuments[caseCheckId] || [];
      const MRLRequiredDocs = MRLDocumentData ? MRLDocumentData[caseCheckId]?.required_documents : null
      if(MRLRequiredDocs) {
        MRLRequiredDocs?.forEach(requiredDocument => {
          let docNotUploaded = true;
          const docID = requiredDocument.id;
          const isMandatory = requiredDocument.is_mandatory;
          for (var j in checkUploadedDocuments) {
            if (checkUploadedDocuments[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if (isMandatory == 1) {
              updatedErrorData[`${requiredDocument.document_name}`] =
              docNotUploaded;
          }
        })
      } else {
        for (var i in checkRequiredDocuments) {
          let docNotUploaded = true;
          const docID = checkRequiredDocuments[i].id;
          const isMandatory = checkRequiredDocuments[i].is_mandatory;
          for (var j in checkUploadedDocuments) {
            if (checkUploadedDocuments[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          if (isMandatory == 1) {
            updatedErrorData[`${checkRequiredDocuments[i].document_name}`] =
              docNotUploaded;
          }
        }
      }
    }

    // setErrorData(updatedErrorData);
    setAllFormInputErrors((prevstate) => ({
      ...prevstate,
      [caseCheckId]: updatedErrorData,
    }));

    let isThereAnyError = false;

    console.log("updatedErrorData....", updatedErrorData)
    for (var i in updatedErrorData) {
      if (updatedErrorData[i] == true && i != "till_date") {
        // setIsLoading(false);
        isThereAnyError = true;
        break;
      }
    }
    if (
      otherVerificationError[caseCheckId] ||
      otherDesignationError[caseCheckId] ||
      otherReasonLeavingError[caseCheckId]
    ) {
      // setIsLoading(false);
      isThereAnyError = true;
    }

    if (isThereAnyError) {
      const errorMsg = addFlag ? "Please fill the current form & then click 'Add Employment'" : "Please fill all required fields.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // window.scroll({ top: 0, left: 0, behavior: "smooth" });
      setTimeout(()=>{
        handleScroll();
      },500)
      return false;
    }
    if (!isThereAnyError) {
      if(!addFlag) {
        createPayloadForSave(caseCheckId);
      } else {
        return true;
      }
    }
  };

  const createPayloadForSave = (caseCheckId, addFlag) => {
    // setIsLoading(true);
    // const caseCheckId = checkData.case_check_id;
    const checkData = checksDetails.find(check => check.case_check_id === caseCheckId);
    const { fields } = checkData || {};
    let fieldInput = {...allFormInputsField[caseCheckId]};
    let savedDetailsObj = {};
    const currencyMasterData = JSON.parse(localStorage.getItem("currency"));
    const fieldDetails = { ...fields };
    const caseMobileCodes = mobileCode[caseCheckId] || {}
    for (var i in fieldDetails) {
      if (fieldInput[i] !== "" && fieldInput[i] !== null) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldInput[i];
      }
      if (fieldInput[i] === "" && fieldDetails[i].label === "Till Date") {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldInput[i]; //needs to be done in general way
      }

      if (fieldDetails[i].label === "Date of leaving") {
        if (tillDateChecked[caseCheckId] === true) {
          savedDetailsObj[`${fieldDetails[i].id}`] = "";
        }
      }

      if (
        fieldDetails[i].label ===
        "Date by when you can provide the reliveing letter"
      ) {
        if (!(tillDateChecked[caseCheckId] && tillDateChecked[caseCheckId] === true)) {
          savedDetailsObj[`${fieldDetails[i].id}`] = "";
        }
      }
      if (fieldDetails[i].label === "Salary Currency") {
        let currencyDt = "";
        if (currencyMasterData?.length) {
          currencyDt = currencyMasterData?.find(
            (currencyData) => currencyData?.label?.currency == fieldInput[i]
          );
          if (currencyDt) {
            savedDetailsObj[`${fieldDetails[i].id}`] =
              currencyDt?.label?.short_name;
          }
        }
      }
    }
    // setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    finalData[`${caseCheckId}`]["group"] = "employment";
    finalData[`${caseCheckId}`]["company_contact_no_code"] =
      fieldInput.company_contact_no
        ? fieldDetails?.company_contact_no?.country_code_value
        : "91";
    finalData[`${caseCheckId}`]["mobile_code_manager"] =
      fieldInput.manager_mobile_no ? caseMobileCodes.mobile_code_manager : "91";
    finalData[`${caseCheckId}`]["mobile_code_manager1"] =
      fieldInput.manager_mobile_no1 ? caseMobileCodes.mobile_code_manager1 : "91";
    finalData[`${caseCheckId}`]["mobile_code_hr"] = fieldInput.hr_mobile_no
      ? caseMobileCodes.mobile_code_hr
      : "91";
    if (showOtherVerificationSource[caseCheckId] == true) {
      finalData[`${caseCheckId}`]["otherVerificationSource"] =
        otherVerificationSource[caseCheckId];
    }
    if (showOtherDesignation[caseCheckId] == true) {
      finalData[`${caseCheckId}`]["17"] = otherDesignation[caseCheckId];
    }
    if (showOtherReasonLeaving[caseCheckId] == true) {
      finalData[`${caseCheckId}`]["77"] = otherReasonLeaving[caseCheckId];
    }
    // if (showOtherLocation[caseCheckId] == true) {
    //   finalData[`${caseCheckId}`]["18"] = otherLocation[caseCheckId];
    // }
    if(addFlag){
      finalData[`${caseCheckId}`].is_final_tab = 0;
    }
    if(!addFlag) {
      checkForValidationandGap(finalData, caseCheckId);
    } else {
      return ({
        finalData,
        caseCheckId
      });
    }
  };

  const checkForValidationandGap = async (finalData, caseCheckId) => {
    // const caseCheckId = checkData.case_check_id;
    const checkData = checksDetails.find(check => check.case_check_id === caseCheckId);
    const indexOfCheckData = checksDetails.findIndex(check => check.case_check_id === caseCheckId);
    const index = indexOfCheckData + 1
    if (true || checksDetails?.length == index) { // always check validation in all tab
      if(checksDetails?.length == index) {
        finalData[`${caseCheckId}`]["is_final_tab"] = "1";
      } else {
        finalData[`${caseCheckId}`]["is_final_tab"] = "0";
      }
      if (true || (is_employment_validation && is_employment_validation == "1"))  { // always check validation and gap
        const result = await dispatch(
          getEmploymentValidation(caseCheckId, finalData)
        );
        if (result) {
          if (result?.data?.valid == "1") {
            if (is_gap_reason && is_gap_reason == "1" && result?.data?.show_gap === 1) {  // Gap only to be checked in last tab
              const gapReasonResult = await dispatch(
                getEmploymentGapReason(
                  caseCheckId,
                  finalData,
                  result?.data?.show_declaration
                )
              );
              if (
                gapReasonResult.data &&
                Object.keys(gapReasonResult.data).length > 0 &&
                gapReasonResult?.message != "No gap found."
              ) {
                setGapData(gapReasonResult.data);
                setFinalCaseCheckId(caseCheckId);
                setFinalDataToBeSent(finalData);
                if (
                  Object.keys(gapReasonResult.data.responseArr).includes(
                    "eduemp"
                  )
                ) {
                  setGapReasonKey("eduemp");
                }
                setHasGap(true);
              } else {
                dispatch(
                  saveEmployment(
                    caseCheckId,
                    finalData,
                    index,
                    saveEmploymentCallback
                  )
                );
              }
            } else {
              dispatch(
                saveEmployment(
                  caseCheckId,
                  finalData,
                  index,
                  saveEmploymentCallback
                )
              );
            }
          } else {
            // alert(result.data.msg);
            setFinalCaseCheckId(caseCheckId);
            setFinalDataToBeSent(finalData);
            setEtypeInfo(result);
            // setEtypeErrorPopUp(true);

            if (result.data.add_emp) {
              const condition = result.data.add_emp == 1 ? false : true;
              setCheckForAddEmployment(condition);
            } else {
              setCheckForAddEmployment(true);
            }
            return;
          }
        }
      } else if (is_gap_reason && is_gap_reason == "1") {
        const gapReasonResult = await dispatch(
          getEmploymentGapReason(checkData.case_check_id, finalData)
        );
        if (
          gapReasonResult.data &&
          Object.keys(gapReasonResult.data).length > 0 &&
          gapReasonResult?.message != "No gap found."
        ) {
          setGapData(gapReasonResult.data);
          setFinalCaseCheckId(caseCheckId);
          setFinalDataToBeSent(finalData);
          if (
            Object.keys(gapReasonResult.data.responseArr).includes("eduemp")
          ) {
            setGapReasonKey("eduemp");
          }
          setHasGap(true);
        } else {
          dispatch(
            saveEmployment(
              caseCheckId,
              finalData,
              index,
              saveEmploymentCallback
            )
          );
        }
      } else {
        dispatch(
          saveEmployment(caseCheckId, finalData, index, saveEmploymentCallback)
        );
      }
    } else {
      finalData[`${caseCheckId}`]["is_final_tab"] = "0";
      dispatch(
        saveEmployment(caseCheckId, finalData, index, saveEmploymentCallback)
      );
    }
  };

  const saveActiveCheckAndProceedAdd = async () => {
    const checkData = checksDetails?.find(check => check?.case_check_id == activeTab);
    const addFlag = true;
    if(checkData?.case_check_id){
     const validFlag =  checkForMandatoryError(checkData?.case_check_id, addFlag);
     if(validFlag) {
      const finalCheckData = createPayloadForSave(checkData?.case_check_id, addFlag);
      if(finalCheckData?.finalData && finalCheckData?.caseCheckId) {
        await dispatch(addEmployment());
        await dispatch(getData());
        // reRenderAgain(unsavedEmpData);
        await dispatch(saveEmployment(finalCheckData?.caseCheckId, finalCheckData?.finalData, activeTab));
        dispatch(getEmployment());
        setShowAddPopup(false);
        // proceedAdd();
      }
     }
    }
      setShowAddPopup(false);
  }

  const closeStatusPopUp = (e) => {
    e?.preventDefault();
    setEmploymentStatus(tempEmploymentStatus)
    setTempEmploymentStatus(0);
    setShowStatusPopUp(false);
    setCurrentStatusDropdownFlag(is_disable_emp_question || 0)
  }

  const proceedStatusPopUp = (e) => {
    e?.preventDefault();
    dispatch(saveEmployementExperienceOption(employmentStatus, getGroupInfo));
    setShowStatusPopUp(false);
  }

  const closeOverlapPopUp = (e) => {
    e?.preventDefault();
    setShowETypeOverlap(false);
  }

  const resetOthersField = () => {
    setShowOtherVerificationSource({});
    setOtherVerificationSource({});
    setOtherVerificationError({});

    setOtherDesignation({});
    setShowOtherDesignation({});
    setOtherDesignationError({});

    setOtherReasonLeaving({});
    setShowOtherReasonLeaving({});
    setOtherReasonLeavingError({});

    setOtherLocation({});
    setShowOtherLocation({});
    setOtherLocationError({});
  }

  const getMRLDocList = (checksDetails) => {
    Object.entries(checksDetails).forEach(([key, check]) => {
      if(check?.verification_source_id || check?.verification_source_name) { // in case of other source id is remain null
        let payload = {
          verification_type: 2,
          org_id: check?.verification_source_id || "other",
          check_id: check?.check_id
        }
         dispatch(getMRLDocument(payload, check?.case_check_id))
      }
    });
  }
 
  // useEffect(() => {
  //   console.log("all input fields", allFormInputsField);
  //   console.log("all input errors", allFormInputErrors);
  //   console.log("activeTab...", activeTab)
  // });

  return (
    <>
      {showAddPopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Employment"
          description="Are you sure you want to add another employment?"
          proceedHandler={(e) => {
            e?.preventDefault();
            saveActiveCheckAndProceedAdd();
            // proceedAdd();
          }}
          isAdd={true}
        />
      )}
      {/* {showStatusPopUp == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeStatusPopUp}
          title={
            showDisableWarning
              ? "Your employment status will be locked"
              : "Do you want to change the employment status?"
          }
          description={
            showDisableWarning
              ? "Kindly ensure you have made correct selection. Once you confirm, your employment status will be locked & you cannot change it later."
              : "If you change the employment status, all data entered in employment form will be lost. Click proceed to change the employment status"
          }
          proceedHandler={proceedStatusPopUp}
          isAdd={false}
          checkStatus={""}
          yesOption={showDisableWarning ? "Confirm" : "Proceed"}
          noOption={"Cancel"}
        />
      )} */}
      {showStatusPopUp == true && (
        <EmpStatusConfirmationPopup
          showModalBox={1}
          closePopup={closeStatusPopUp}
          title={!!(showStatusDOJ && employmentStatus == 3 && !candidates?.employment_status) ? "" : `Do you want to change the employment status?`}
          description={!!(showStatusDOJ && employmentStatus == 3 && !candidates?.employment_status) ? "" : `If you change the employment status, the forms will reset & all data entered in employment form will be lost. Click proceed to change the employment status.`}
          proceedHandler={proceedStatusPopUp}
          isAdd={false}
          checkStatus={""}
          yesOption={"Proceed"}
          noOption={"Cancel"}
          showStatusDOJ={showStatusDOJ && employmentStatus == 3}
        />
      )}
      {showETypeOverlap == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeOverlapPopUp}
          title={etypeInfo?.data?.etype}
          description={etypeInfo?.data?.msg}
          proceedHandler={closeOverlapPopUp}
          isAdd={false}
          checkStatus={""}
          yesOption={"Edit"}
          noOption={"Cancel"}
        />
      )}
      {/* {hasGap && (
        <EmploymentGaps
          gapData={gapData}
          closeGapPopUp={closeGapPopUp}
          handleGapReasonSubmit={handleGapReasonSubmit}
          gapReasonKey={gapReasonKey}
          gapName="Employment"
        />
      )} */}
      {showAlertPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={() => {
            setShowAlertPopUp(false);
            dispatch(deleteAddEmploymentData());
          }}
          title="Confirm"
          description="Maximum employments already added"
          proceedHandler={() => {
            setShowAlertPopUp(false);
            dispatch(deleteAddEmploymentData());
          }}
          isAdd={false}
          yesOption={"Okay"}
          noOption={"Cancel"}
        />
      )}
      {etypeErrorPopUp && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={(e) => {
            e?.preventDefault();
            setEtypeErrorPopUp(false);
            setEtypeInfo(null);
          }}
          title={etypeInfo?.data?.etype}
          description={etypeInfo?.data?.msg}
          proceedHandler={(e) => {
            e?.preventDefault();
            setEtypeErrorPopUp(false);
            setEtypeInfo(null);
          }}
          isAdd={false}
        />
      )}
      {etypeShowGap && (
        <TenureAlertPopUp
          showModalBox={1}
          closePopup={(e) => {
            e?.preventDefault();
            setETypeShowGap(false);
            setEtypeInfo(null);
          }}
          title={etypeInfo?.data?.etype}
          description={etypeInfo?.data?.msg}
          proceedHandler={(e) => {
            e?.preventDefault();
            proceedTenureAlert();
          }}
          addEmploymentHandler={(e) => {
            e?.preventDefault();
            setETypeShowGap(false);
            setEtypeInfo(null);
            handleAddEmployment();
          }}
          isAdd={false}
          employmentReason={candidates?.employment_reason}
          currentCheck={checksDetails?.find(
            (check) => check?.case_check_id == activeTab
          )}
          isFinalTab={lastTabCaseCheckId == activeTab}
        />
      )}
      {!!(loading || employmentSaveDataLoading) && <Loader />}
      <div className="" style={{ background: "#F9FAFB" }}>
        <div
          className="formHeading mb-3 border-bottom"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <FormHeading
            heading="Employment"
            subHeading={
              !!(
                candidates?.employment_status &&
                candidates?.employment_status > 1
              )
                ? employment_config_msg || ""
                : ""
              // "Add your highest education degree/certificate/all marksheets."
            }
          />
          {/* {!!(
            !!tabs?.length &&
            !hasGap &&
            candidates?.employment_status > 1 &&
            is_custom_employement == 1 &&
            !((candidates?.employment_status === 2 || candidates?.employment_status === 3) && catchIfAllStatusMigrated)
          ) && (
            <button
              className="btn btn-primary mb-3"
              style={{ height: 40, padding: ".375rem .75rem" }}
              onClick={(e) => handleAddPopup(e)}
            >
              + Add Employment
            </button>
          )} */}
        </div>
        {!hasGap && (
          <div className="row" style={{
            background: "white",
            border: "1px solid #E4E7EC",
            borderRadius: 8,
            paddingTop: 26,
            marginBottom: 20,
            backgroundSize: "initial",
            marginLeft: 0,
            marginRight: 0,
            maxWidth: !!(is_disable_emp_question && statusDropdownOptions?.length > 1) ? 650 : 520,
          }}>
            <div className={`${!!(is_disable_emp_question && statusDropdownOptions?.length > 1) ? "col-lg-9 " : "col-lg-12"} col-md-12 col-sm-12`}>
              <EmpLoymentQuestionDropdown
                label="Select your employment status:"
                labelStyle={{ color: "#6B7280" }}
                options={statusDropdownOptions}
                value={employmentStatus}
                selected={employmentStatus}
                currentSavedEmploymentStatus={candidates?.employment_status}
                catchIfAllStatusInComplete={catchIfAllStatusInComplete}
                onChange={handleDropdownChangeInternal}
                isDisableEmpQuestion={currentStatusDropdownFlag}
              />
            </div>
            {!!(is_disable_emp_question && statusDropdownOptions?.length > 1) && (
              <div className="emp-status-edit col-auto" style={{ display: "flex" }}>
                {!!currentStatusDropdownFlag && (
                  <div className="mb-3">
                  <button
                    className="btn btn-edit btn-lg btn-block"
                    style={{
                      height: 47,
                      padding: "10px 18px"
                    }}
                    onClick={(e) => {
                      e?.preventDefault();
                      setCurrentStatusDropdownFlag(0);
                    }}
                  ><FeatherIcon size={16} icon="edit-2" />
                    {" "}Edit
                  </button>
                </div>
                )}
                {!currentStatusDropdownFlag && (
                  <div className="mb-3">
                    <button
                      className="btn btn-outline-secondary btn-lg btn-block"
                      style={{
                        height: 47,
                        padding: "10px 18px"
                      }}
                      onClick={(e) => {
                        e?.preventDefault();
                        setCurrentStatusDropdownFlag(1);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {hasGap && (
        <EmploymentGapFormWrapper
          gapData={gapData}
          closeGapPopUp={closeGapPopUp}
          handleGapReasonSubmit={handleGapReasonSubmit}
          gapReasonKey={gapReasonKey}
          gapName="Employment"
        />
      )}
      {!!(!!tabs?.length && !hasGap && candidates?.employment_status > 1) ? (
        <div ref={ref}>
          <EmploymentTab
            checksDetails={checksDetails}
            changeTab={changeTab}
            setActiveTab={setActiveTab}
          />
          {/* <Tabs tabs={tabs} /> */}
          <Routes>
            {tabs.map((tab) => (
              <Route key={tab.path} path={tab.path} element={tab.content} />
            ))}
          </Routes>
        </div>
      ) : (
        !hasGap && (
          <>
            <div className="d-flex">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <button
                  className="btn btn-primary mb-3"
                  onClick={(e) => handleNextNavigation(e)}
                  disabled={!employmentStatus}
                >
                  Continue
                </button>
              </div>
            </div>
          </>
        )
      )}
      {showProfilePreview == 1 && (
        <div className="row">
          <div className="col-auto d-flex justify-content-between">
            <button
              className="btn btn-primary btn-lg btn-block mt-3"
              onClick={(e) => handleSubmitForPreview(e)}
            >
              {clientId == 459831 ? "Preview" : "Submit for Preview"}
            </button>
          </div>
          <div className="col-auto d-flex justify-content-between mt-4">
            <small className="text-muted">
              Please complete all the mandatory fields before final submission
            </small>
          </div>
        </div>
      )}
    </>
  );
};

export default FormContainer;